import React from "react";

// Resolve Iconify-compatible icon IDs from portfolio entries and known names
function resolveIconifyId(
  fontAwesomeClassname?: string,
  skillName?: string,
): string {
  const id = (fontAwesomeClassname || "").trim();
  // If already an Iconify id (contains a namespace separator), use it
  if (id.includes(":")) return id;

  const key = (skillName || "").toLowerCase().trim();
  const FALLBACKS: Record<string, string> = {
    swagger: "simple-icons:swagger",
    "drizzle orm": "mdi:table",
    drizzle: "mdi:table",
    "apache kafka": "simple-icons:apachekafka",
    kafka: "simple-icons:apachekafka",
    rabbitmq: "simple-icons:rabbitmq",
    postman: "simple-icons:postman",
    jira: "simple-icons:jira",
    redis: "simple-icons:redis",
    sqlite: "simple-icons:sqlite",
    firebase: "simple-icons:firebase",
    "vue.js": "simple-icons:vuedotjs",
    vue: "simple-icons:vuedotjs",
    mendix: "simple-icons:mendix",
    css3: "simple-icons:css3",
  };

  if (FALLBACKS[key]) return FALLBACKS[key];
  // Generic fallback dot icon
  return "mdi:checkbox-blank-circle-outline";
}

interface Logo {
  skillName: string;
  fontAwesomeClassname?: string;
  style?: React.CSSProperties;
}

interface SoftwareSkillProps {
  logos: Logo[];
}

const SoftwareSkill: React.FC<SoftwareSkillProps> = ({ logos }) => {
  return (
    <div>
      <div>
        <ul className="flex flex-wrap justify-center items-center gap-4 p-0 m-0 list-none">
          {logos?.map((logo) => (
            <li
              key={logo.skillName}
              className="group flex items-center justify-center w-12 h-12 md:w-16 md:h-16 transition-all duration-300 cursor-pointer"
              title={logo.skillName}
              data-name={logo.skillName}
            >
              <span
                className="iconify text-2xl md:text-4xl text-gray-600 group-hover:text-[#645beb] transition-all duration-300 group-hover:scale-110 group-hover:rotate-12 inline-block"
                data-icon={resolveIconifyId(
                  logo.fontAwesomeClassname,
                  logo.skillName,
                )}
                style={logo.style}
                data-inline="false"
              />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default SoftwareSkill;
